function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { loadRemoteModule } from '../helpers/loadRemoteModule';
import { promiseWithRetries } from '../helpers/promiseWithRetries';
import { setVersionOnEntriesFile } from '../helpers/setVersionOnEntriesFile';
import { sendImportRemoteRuntimeEvent } from './events';
import { getRemoteRuntime } from './runtime';
const MAX_RETRIES = 3;
const IMPORT_REMOTE_RETRY_TYPES = {
  GET_REMOTE: 'IMPORT_REMOTE_RETRY__GET_REMOTE',
  RESOLVE_REMOTE: 'IMPORT_REMOTE_RETRY__RESOLVE_REMOTE'
};
export async function importRemote(_ref) {
  let {
    scope,
    module,
    version,
    onRetry = () => {}
  } = _ref;
  const performanceMark = globalThis.performance.mark('importRemoteStart');
  let remote;
  try {
    const scopeRuntimeInfoResponse = await promiseWithRetries(async () => {
      const remoteRuntimeInfo = getRemoteRuntime(scope);
      if (!remoteRuntimeInfo) {
        throw new Error("ExoSkeletonAPI Error: No remote found for scope \"".concat(scope, "\""));
      }
      let url;
      if (!remoteRuntimeInfo.hasOwnProperty('url')) {
        console.warn('Deprecation warning: getting remote URL in async way');
        url = (await remoteRuntimeInfo.get()).url;
      } else {
        url = remoteRuntimeInfo.url;
      }
      return _objectSpread(_objectSpread({}, remoteRuntimeInfo), {}, {
        url
      });
    }, {
      retries: MAX_RETRIES,
      onRetry(error, tryAttempt) {
        return onRetry({
          error,
          tryAttempt,
          retryName: IMPORT_REMOTE_RETRY_TYPES.GET_REMOTE
        });
      }
    });
    remote = scopeRuntimeInfoResponse;
  } catch (cause) {
    throw new Error("ExoSkeletonAPI Error: Failed to get the remote for scope \"".concat(scope, "\"\n").concat(cause), {
      cause
    });
  }
  const {
    url: rawUrl,
    override
  } = remote;
  const url = version && !override ? setVersionOnEntriesFile({
    url: rawUrl,
    version
  }) : rawUrl;
  try {
    let importTryAttempt = 0;
    const resolvedPromise = await promiseWithRetries(_ref2 => {
      let {
        attempt
      } = _ref2;
      return loadRemoteModule({
        bustRemoteEntryCache: attempt > 1,
        scope,
        url,
        module,
        version
      });
    }, {
      retries: MAX_RETRIES,
      onRetry(error, tryAttempt) {
        importTryAttempt = tryAttempt;
        return onRetry({
          error,
          tryAttempt,
          retryName: IMPORT_REMOTE_RETRY_TYPES.RESOLVE_REMOTE
        });
      }
    });
    void sendImportRemoteRuntimeEvent({
      scope,
      metadata: {
        url,
        retryAttempt: importTryAttempt,
        timeToImport: globalThis.performance.now() - performanceMark.startTime
      }
    });
    return resolvedPromise;
  } catch (cause) {
    throw new Error("ExoSkeletonAPI Error: Failed to resolve remote \"".concat(module, "\" from scope \"").concat(scope, "\"\n").concat(cause), {
      cause
    });
  } finally {
    globalThis.performance.clearMarks('importRemoteStart');
  }
}
//# sourceMappingURL=import.js.map